<template>
  <div class="single-video">
    <!-- youtube div element -->
    <vue-plyr
      ref="plyr"
      :options="plyrOptions"
      :crossorigin="true"
    >
      <div
        data-plyr-provider="youtube"
        :data-plyr-embed-id="pid"
      />
    </vue-plyr>
  </div>
</template>

<script>
/* eslint-disable default-case */

export default {
  props: {
    video: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      isBuffered: false,
      isPlaying: false,

      plyrOptions: {
        debug: false,
        controls: `
        <div class="plyr__controls">
            <button type="button" class="plyr__control" aria-label="Play, {title}" data-plyr="play">
                <svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-pause"></use></svg>
                <svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-play"></use></svg>
                <span class="label--pressed plyr__tooltip" role="tooltip">Pause</span>
                <span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span>
            </button>
            <div class="plyr__progress">
                <input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek">
                <progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress>
                <span role="tooltip" class="plyr__tooltip">00:00</span>
            </div>
            <div class="plyr__time plyr__time--current" aria-label="Current time">00:00</div>
            <div class="plyr__time plyr__time--duration" aria-label="Duration">00:00</div>
            <button type="button" class="plyr__control" aria-label="Mute" data-plyr="mute">
                <svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-muted"></use></svg>
                <svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-volume"></use></svg>
                <span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span>
                <span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span>
            </button>
            <div class="plyr__volume">
                <input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume">
            </div>
            <button type="button" class="plyr__control" data-plyr="captions">
                <svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-captions-on"></use></svg>
                <svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-captions-off"></use></svg>
                <span class="label--pressed plyr__tooltip" role="tooltip">Disable captions</span>
                <span class="label--not-pressed plyr__tooltip" role="tooltip">Enable captions</span>
            </button>
            <button type="button" class="plyr__control" data-plyr="fullscreen">
                <svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-exit-fullscreen"></use></svg>
                <svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-enter-fullscreen"></use></svg>
                <span class="label--pressed plyr__tooltip" role="tooltip">Exit fullscreen</span>
                <span class="label--not-pressed plyr__tooltip" role="tooltip">Enter fullscreen</span>
            </button>
        </div>        
        `,
      },
    };
  },

  computed: {
    player() {
      return this.$refs.plyr.player;
    },

    pid() {
      return this.$route.params.pid;
    },
  },

  mounted() {
    this.player.on('ready', () => {
      this.player.play();
    });

    this.player.on('statechange', (event) => {
      $('body').removeClass('video-unstarted');
      $('body').removeClass('video-ended');
      $('body').removeClass('video-playing');
      $('body').removeClass('video-paused');
      $('body').removeClass('video-buffering');
      $('body').removeClass('video-cued');

      switch (event.detail.code) {
        case -1:
          $('body').addClass('video-unstarted');
          break;
        case 0:
          $('body').addClass('video-ended').removeClass('video-displayed');
          break;
        case 1:
          $('body').addClass('video-playing');
          break;
        case 2:
          $('body').addClass('video-paused');
          break;
        case 3:
          $('body').addClass('video-buffering');
          break;
        case 5:
          $('body').addClass('video-cued');
          break;
      }
    });
  },
};
</script>

<style>
.plyr__video-embed iframe {
  top: -50%;
  height: 200%;
}
</style>
